import { render } from "./TimeItem.vue?vue&type=template&id=1acb688c&scoped=true"
import script from "./TimeItem.vue?vue&type=script&lang=js"
export * from "./TimeItem.vue?vue&type=script&lang=js"

import "./TimeItem.vue?vue&type=style&index=0&id=1acb688c&scoped=true&lang=css"

import exportComponent from "/home/viewchat/public_html/viewchat-web-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1acb688c"]])

export default __exports__